import React, { SVGAttributes } from 'react';

interface Props extends SVGAttributes<SVGSVGElement> {
  color?: string;
}

const OcEmpty = ({ ...props }: Props) => (
  <svg
    width="360"
    height="250"
    viewBox="0 0 360 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <svg
      width="360"
      height="250"
      viewBox="0 0 360 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6562_496009)">
        <rect width="360" height="250" fill="url(#paint0_radial_6562_496009)" />
        <path
          d="M151.759 158.948C152.839 157.859 155.605 147.837 175.689 145.701"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M189.364 145.701C192.356 146.555 201.562 148.314 205.603 152.88C217.578 166.409 220.98 191.484 205.261 217.235"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M146.802 178.431C150.415 179.791 156.374 179.202 160.305 175.784"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M184.329 293.383C154.802 311.844 159.388 244.894 161.408 212.363C182.848 219.029 200.21 214.756 204.056 208.688C205.148 212.56 208.532 240.287 208.816 248.173C209.273 260.822 210.486 290.476 193.689 296.46C189.545 297.937 186.523 296.61 184.329 293.383Z"
          fill="#211249"
        />
        <path
          d="M160.819 181.167C159.452 193.731 160.725 208.516 161.751 212.362C172.119 215.439 195.065 218.977 203.885 208.516C204.283 206.693 205.689 188.261 203.296 178.774"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M170.552 161.939L171.924 159.832C173.261 157.779 175.866 156.959 178.138 157.876L181.409 159.195C183.45 160.018 185.789 159.447 187.221 157.776L190.978 153.393"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M189.441 146.454C190.211 144.232 189.51 142.736 188.826 142.452C184.724 146.212 178.502 144.816 176.194 142.537C175.374 143.289 175.852 145.514 176.194 146.198C180.638 151.12 186.963 148.363 189.441 146.454Z"
          fill="#211249"
        />
        <path
          d="M133.913 164.283C132.638 157.634 133.907 142.668 141.555 133.49C143.842 131.694 149.014 130.524 151.407 140.217C150.661 144.567 150.89 151.083 151.379 156.624C152.153 165.386 148.301 176.689 142.865 177.43C137.43 178.171 134.632 168.974 133.913 164.283Z"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M141.581 133.507C145.143 129.188 152.47 121.7 162.713 119.689C163.689 119.377 165.697 119.117 165.924 120.577C166.208 122.403 162.898 121.535 158.823 124.916"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M155.922 127.922C157.767 128.412 161.245 129.846 160.401 131.655C160.242 132.028 159.727 132.817 158.944 132.984"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M155.656 130.671C157.197 131.108 160.011 132.518 158.942 134.664C157.873 136.81 156.194 137.021 155.489 136.858C154.77 136.728 153.628 136.262 153.761 135.349C153.791 135.142 153.887 134.912 154.067 134.658C155.046 133.282 155.709 134.24 155.918 134.89"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M152.702 125.446C155.257 124.798 160.564 124.429 161.354 128.144C161.473 128.54 161.378 129.342 160.042 129.373"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M151.389 140.136C151.831 137.591 152.605 135.783 153.854 135.333"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M201.225 111.517C199.345 118.268 198.405 118.867 195.67 121.858C195.67 118.902 195.162 113.94 195.162 111.873C186.207 111.873 178.65 108.218 175.991 106.39C176.086 112.589 170.275 116.642 170.275 116.642C170.275 116.642 171.109 119.145 171.584 124.747C171.965 129.229 170.869 128.363 170.275 127.37C168.56 121.839 165.75 123.317 164.559 124.747C149.946 101.004 172.418 96.4167 176.705 96.8538C179.944 94.0882 184.46 91.921 187.636 91.6031C199.088 90.4567 204.275 100.569 201.225 111.517Z"
          fill="#211249"
        />
        <path
          d="M170.474 131.597C172.012 140.989 182.338 147.742 189.789 140.134C197.24 132.526 195.749 118.6 194.953 112.101"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M164.39 124.166C163.45 126.474 164.332 131.587 170.475 131.587"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M167.098 125.435C166.963 125.928 167.071 127.098 168.594 127.828"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M194.746 130.39C196.751 129.555 198.165 126.459 197.621 121.502"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M183.465 136.031C184.578 133.649 185.306 135.133 186.798 133.895"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M189.2 126.741C189.908 126.741 190.482 126.167 190.482 125.459C190.482 124.751 189.908 124.177 189.2 124.177C188.492 124.177 187.918 124.751 187.918 125.459C187.918 126.167 188.492 126.741 189.2 126.741Z"
          fill="#211249"
        />
        <path
          d="M177.918 126.912C178.626 126.912 179.2 126.338 179.2 125.63C179.2 124.922 178.626 124.348 177.918 124.348C177.21 124.348 176.636 124.922 176.636 125.63C176.636 126.338 177.21 126.912 177.918 126.912Z"
          fill="#211249"
        />
        <path
          d="M175.26 121.331C175.53 120.537 176.694 119.068 179.191 119.544"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M187.226 119.794C187.822 119.278 189.441 118.556 191.157 119.794"
          stroke="#211249"
          strokeLinecap="round"
        />
        <path
          d="M183.092 123.383C182.892 125.071 182.757 128.493 183.808 128.682"
          stroke="#211249"
          strokeLinecap="round"
        />
        <rect
          x="41.1706"
          y="140.039"
          width="21.5366"
          height="18.7073"
          rx="2.28026"
          transform="rotate(-28.4668 41.1706 140.039)"
          stroke="#211249"
          strokeWidth="1.72692"
        />
        <rect
          x="73.0969"
          y="84.1453"
          width="21.851"
          height="27.5097"
          rx="2.28026"
          transform="rotate(37.6824 73.0969 84.1453)"
          stroke="#211249"
          strokeWidth="1.72692"
        />
        <rect
          x="99.1504"
          y="216.644"
          width="21.5366"
          height="50.7732"
          rx="2.28026"
          transform="rotate(17.4666 99.1504 216.644)"
          stroke="#211249"
          strokeWidth="1.72692"
        />
        <path
          d="M249.669 137.739C250.915 134.515 256.139 128.46 258.943 125.465C259.082 125.315 259.062 125.079 258.899 124.956L248.57 117.182C248.45 117.092 248.287 117.089 248.17 117.182C245.745 119.102 240.898 125.923 238.56 129.419C238.46 129.569 238.495 129.768 238.637 129.878L249.107 137.907C249.299 138.055 249.582 137.965 249.669 137.739Z"
          stroke="#211249"
          strokeWidth="1.72692"
          strokeLinecap="round"
        />
        <path
          d="M271.216 71.8407C271.261 68.6537 272.171 61.2728 275.417 56.487C275.565 56.2696 275.436 55.966 275.177 55.9261C272.692 55.5456 267.295 54.304 261.386 51.6858C261.228 51.6158 261.043 51.6716 260.956 51.8204C259.504 54.2965 256.745 60.2782 256.091 66.6066C256.077 66.7481 256.15 66.8826 256.278 66.9448C259.618 68.5624 266.513 71.5088 269.015 71.1142"
          stroke="#211249"
          strokeWidth="1.72692"
          strokeLinecap="round"
        />
        <path
          d="M287.362 48.9997L297.892 44.5227"
          stroke="#211249"
          strokeWidth="1.72692"
          strokeLinecap="round"
        />
        <path
          d="M284.653 46.0027L296.275 37.0277"
          stroke="#211249"
          strokeWidth="1.72692"
          strokeLinecap="round"
        />
        <path
          d="M281.108 42.0498C283.511 40.3427 288.998 35.4263 291.721 29.4177"
          stroke="#211249"
          strokeWidth="1.72692"
          strokeLinecap="round"
        />
        <path
          d="M237.396 69.1987C238.849 76.0965 248.304 88.6127 274.469 84.5282C275.044 84.4385 275.492 85.0513 275.211 85.5606C268.86 97.0969 262.234 117.102 288.3 134.069C299.632 141.445 313.165 138.795 306.574 128.081C297.604 113.5 264.043 140.93 269.874 166.416"
          stroke="#211249"
          strokeWidth="1.72692"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_6562_496009"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(180 250) rotate(-90) scale(61.1979 180)"
        >
          <stop stopColor="#F3F3FC" />
          <stop offset="1" stopColor="white" />
        </radialGradient>
        <clipPath id="clip0_6562_496009">
          <rect width="360" height="250" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </svg>
);

export default OcEmpty;
